export default function My404Component() {
    return (
        <div style={{paddingTop: 64, paddingLeft: 24, paddingRight: 24}}>
            <h1>Oops! This page does not existt.</h1>
        </div>
    )
}